import {combineReducers} from 'redux';
import {reducer as formReducer} from 'redux-form';

import customerEditingReducer from '../reducers/customerEditing';
import subscriptionSwitchReducer from '../reducers/subscriptionSwitch';
import {usageReducer} from '../reducers/usage';
import agreementsReducer from './Agreements';
import {availableOptionsReducer} from './AvailableOption';
import bonusesReducer from './Bonuses';
import customerReducer from './Customer';
import deliveryResourcesReducer from './DeliveryResource';
import filesReducer from './Files/reducer';
import internationalReducer from './International';
import legalDocumentsReducer from './LegalDocuments';
import loadingStatusReducer from './LoadingStatus';
import {localizationReducer} from './Localization';
import {newOfferReducer} from './NewOffer';
import nextPlanReducer from './NextPlan';
import notificationsReducer from './Notification';
import {paymentReducer} from './Payment';
import {phoneLinesEditingReducer} from './PhoneLines/reducer';
import {plansReducer} from './Plan';
import promoProductsReducer from './PromoProducts';
import signUpReducer from './SignUp';
import subscriptionReducer from './Subscription';
import themeReducer from './Theme';
import timelineReducer from './Timeline/reducer';
import topUpsReducer from './TopUps';
import {voucherReducer} from './Voucher';
import {voucherAddMoneyReducer} from './VoucherAddMoney/reducer';
import {walletReducer} from './Wallet';
import yourOrdersReducer from './yourOrders';

import {authReducer} from './Authentication/reducer';
import {default as dashboardReducer} from './Dashboard';
import {default as subscriptionsReducer} from './Subscriptions';

const appReducer = combineReducers({
  agreements: agreementsReducer,
  auth: authReducer,
  availableOptions: availableOptionsReducer,
  bonuses: bonusesReducer,
  customer: customerReducer,
  customerEditing: customerEditingReducer,
  files: filesReducer,
  form: formReducer,
  international: internationalReducer,
  legalDocuments: legalDocumentsReducer,
  localization: localizationReducer,
  newOffer: newOfferReducer,
  nextPlan: nextPlanReducer,
  notifications: notificationsReducer,
  payment: paymentReducer,
  phoneLinesEditing: phoneLinesEditingReducer,
  plans: plansReducer,
  promoProducts: promoProductsReducer,
  signUp: signUpReducer,
  subscription: subscriptionReducer,
  subscriptionSwitch: subscriptionSwitchReducer,
  theme: themeReducer,
  timeline: timelineReducer,
  topUps: topUpsReducer,
  usage: usageReducer,
  voucherAddMoney: voucherAddMoneyReducer,
  loadingStatus: loadingStatusReducer,
  subscriptions: subscriptionsReducer,
  dashboard: dashboardReducer,
  deliveryResources: deliveryResourcesReducer,
  yourOrders: yourOrdersReducer,
  wallet: walletReducer,
  voucher: voucherReducer,
});

export default function rootReducer(state: State, action: Action) {
  let newState = state;
  if (action.type === 'RESET_CUSTOMER_DATA') {
    const {localization, theme, yourOrders} = newState;
    newState = {localization, theme, yourOrders};
  }

  return appReducer(newState, action);
}

export type StateType = {|
  auth: AuthStateType,
  availableOptions: AvailableOptionStateType,
  bonuses: BonusesStateType,
  customer: CustomerStateType,
  dashboard: DashboardStateType,
  files: FilesStateType,
  international: InternationalStateType,
  legalDocuments: LegalDocumentsStateType,
  localization: LocalizationStateType,
  notifications: NotificationStateType,
  payment: PaymentStateType,
  phoneLinesEditing: PhoneLinesEditingStateType,
  promoProducts: PromoProductsStateType,
  signUp: SignUpStateType,
  subscriptions: SubscriptionsStateType,
  theme: string,
  wallet: WalletStateType,
  voucher: VoucherStateType,
|};
